module.exports = __webpack_public_path__ + "img/dovf_dovvaultfort.a84b315.png";